import { FormInputGroup } from 'framework/ui/layout';
import { Stack, Typography } from '@mui/material';
import { ClearAfterUnmountWrapper } from 'framework/form';

const FormElement = ({ title, isTeam, isVisible, children }: any) => {
  return (
    <FormInputGroup isVisible={isVisible}>
      <Stack spacing={2} sx={{ pr: !isTeam ? 5.75 : 0 }}>
        <Typography variant="h4" color="primary">
          {title}
        </Typography>
        <ClearAfterUnmountWrapper>{children}</ClearAfterUnmountWrapper>
      </Stack>
    </FormInputGroup>
  );
};

export default FormElement;
